import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { StatusColor } from 'src/app/shared/status-indicator/status-indicator.component';

@Component({
  selector: 'dcc-command-status',
  template: `<dcc-status-indicator
    [color]="statusColor"
    [value]="status"
  ></dcc-status-indicator>`,
})
export class CommandStatusComponent implements ICellRendererAngularComp {
  status: string;
  statusColor: StatusColor;
  // gets called once before the renderer is used
  agInit(params: ICellRendererParams): void {
    this.status = this.getStatusAndCss(params.data.status);
  }

  // gets called whenever the cell refreshes
  refresh(params: ICellRendererParams): boolean {
    // set value into cell again
    this.status = params.data.status;
    return true;
  }

  private getStatusAndCss(status: string): string {
    switch (status) {
      case 'IN_PROGRESS':
        this.statusColor = StatusColor.blue;
        return 'In Progress';
      case 'COMPLETE':
        this.statusColor = StatusColor.green;
        return 'Complete';
      case 'ERROR':
        this.statusColor = StatusColor.red;
        return 'Error';
      case 'COMPLETE_WITH_ERRORS':
        this.statusColor = StatusColor.yellow;
        return 'Complete(but with Errors)';
      default:
        return undefined;
    }
  }
}
